import styled from 'styled-components';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
export var StyledNavigation = styled.nav.withConfig({
  displayName: "Navigationstyles__StyledNavigation",
  componentId: "sc-18oblq3-0"
})(["width:100%;flex:1;overflow:hidden;"]);
export var StyledNavigationIcon = styled(Icon).attrs({
  color: 'var(--dentsu-color-n600)',
  size: 14
}).withConfig({
  displayName: "Navigationstyles__StyledNavigationIcon",
  componentId: "sc-18oblq3-1"
})(["margin-right:8px;position:relative;top:-1px;"]);
export var StyledNavigationList = styled.ul.withConfig({
  displayName: "Navigationstyles__StyledNavigationList",
  componentId: "sc-18oblq3-2"
})(["margin:0;padding:0 12px;&.", "-navigation__sublist{display:none;padding:0;}"], prefix);
export var StyledNavigationSection = styled.div.attrs({
  className: "".concat(prefix, "-navigation__section")
}).withConfig({
  displayName: "Navigationstyles__StyledNavigationSection",
  componentId: "sc-18oblq3-3"
})(["position:relative;+ .", "-navigation__section{&::before{display:block;content:'';margin-top:8px;margin-bottom:8px;margin-left:12px;margin-right:12px;height:1px;background:var(--dentsu-color-n150);}}"], prefix);
export var StyledNavigationTitle = styled.div.withConfig({
  displayName: "Navigationstyles__StyledNavigationTitle",
  componentId: "sc-18oblq3-4"
})(["font-size:12px;padding:14px 24px 14px 24px;line-height:1;color:var(--dentsu-color-n700);text-transform:uppercase;"]);
export var StyledNavigationArrowInput = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Navigationstyles__StyledNavigationArrowInput",
  componentId: "sc-18oblq3-5"
})(["position:absolute;opacity:0;user-select:none;&:checked ~ .", "-navigation__sublist{display:block;}&:not(:checked) ~ .", "-navigation__sublist{display:none;}&:checked ~ .", "-navigation__arrow-label .", "-navigation__arrow-icon{transform:scaleY(-1);}"], prefix, prefix, prefix, prefix);
export var StyledNavigationArrowLabel = styled.label.attrs({
  className: "".concat(prefix, "-navigation__arrow-label")
}).withConfig({
  displayName: "Navigationstyles__StyledNavigationArrowLabel",
  componentId: "sc-18oblq3-6"
})(["display:flex;width:40px;height:40px;border-radius:4px;align-items:center;justify-content:center;position:absolute;top:0;right:0;cursor:pointer;&:hover{background:var(--dentsu-color-n100);}"]);
export var StyledNavigationArrowIcon = styled(Icon).attrs({
  size: 14,
  color: 'var(--dentsu-color-n600)',
  icon: 'chevron-down',
  className: "".concat(prefix, "-navigation__arrow-icon")
}).withConfig({
  displayName: "Navigationstyles__StyledNavigationArrowIcon",
  componentId: "sc-18oblq3-7"
})([""]);
export var StyledNavigationItem = styled.li.withConfig({
  displayName: "Navigationstyles__StyledNavigationItem",
  componentId: "sc-18oblq3-8"
})(["position:relative;"]);
export var StyledNavigationLink = styled.a.withConfig({
  displayName: "Navigationstyles__StyledNavigationLink",
  componentId: "sc-18oblq3-9"
})(["padding:13px 12px 13px 12px;border-radius:var(--dentsu-radius-4);display:block;line-height:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:12px;color:var(--dentsu-color-black);font-weight:var(--dentsu-font-weight-400);user-select:none;&:hover{color:inherit;text-decoration:none;background:var(--dentsu-color-n50);}&.sublist--open ~ .", "-navigation__arrow-label .", "-navigation__arrow-icon{transform:scaleY(-1);}&.sublist--open ~ .", "-navigation__sublist{display:block;}&.selected{background-color:var(--dentsu-color-n50);}&[aria-disabled='true']{pointer-events:none;opacity:0.4;}&.subitem{font-weight:400;border-radius:4px;padding-left:34px;}small{font-weight:400;font-size:12px;margin-left:4px;color:var(--dentsu-color-n700);}"], prefix, prefix, prefix);